import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { catchError, map, mergeMap, take, tap } from 'rxjs/operators';
import { UsersDataService } from './users-data.service';
import { environment } from '../../environments/environment';
import { of, throwError } from 'rxjs';
import { ClinicPublicInfo } from '../common.interface';
import { ApiService } from './api.service';
import { ToastrService } from 'ngx-toastr';
import { Roles } from '../common.constants';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  user;
  constructor(
    private usersDataService: UsersDataService,
    private authService: AuthService,
    private router: Router,
    private api: ApiService,
    private toastr: ToastrService,
    ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    ) {

    return this.authService.user$.pipe(
      take(1),
      mergeMap(user => {
        if (!user) {
          return of({});
        }
        this.user = user;
        this.usersDataService.setUserRole(user.role);
        const clinicRefCode = user.clinicRef;

        const opt = {
          url: `${environment.apiUrls.clinic}${clinicRefCode}/`,
          withSpinner: false,
        };
        return !clinicRefCode ? of({}) : this.api.get(opt).pipe(
          catchError(err => {
            this.toastr.error(`Can't find clinic with ref code "${clinicRefCode}"`);
            this.router.navigate(['/404']);
            return throwError(err);
          }),
          tap((info: ClinicPublicInfo) => {
            if (info.id && info.is_active) {
              this.usersDataService.setLoggedClinicPublicData(info);
              this.usersDataService.setLoggedClinicRefOnly(clinicRefCode);
            } else if (user.role !== Roles.CLINIC_ADMIN) {
              this.toastr.error(`Clinic with ref code "${clinicRefCode}" not active`);
              this.router.navigate(['/404']);
            }
          }),
        );
      }),
      map((info: ClinicPublicInfo) => {
        return !!this.user || this.router.createUrlTree(
          ['/sign-in'], {queryParams: { returnUrl: state.url}}
        );
      }),
    );
  }
}
